export class SKSubscriptionPeriod {
    constructor(numberOfUnits, unit) {
        this.numberOfUnits = numberOfUnits;
        this.unit = unit;
    }
}
//# sourceMappingURL=SKSubscriptionPeriod.js.map